import { c as _c } from "react/compiler-runtime";
import React from "react";
import { faClock } from "@fortawesome/free-regular-svg-icons";
import { faTrophy } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
interface WinnerDropBadgeProps {
  rank: number | null;
  position?: number | undefined;
  decisionTime: number | null;
  variant?: "default" | "simple" | undefined;
}
const WinnerDropBadge: React.FC<WinnerDropBadgeProps> = t0 => {
  const $ = _c(26);
  const {
    rank,
    position: t1,
    decisionTime,
    variant: t2
  } = t0;
  const position = t1 === undefined ? 1 : t1;
  const variant = t2 === undefined ? "default" : t2;
  const effectiveRank = rank !== null && rank !== undefined ? rank : position;
  if (!effectiveRank) {
    return null;
  }
  const rankNumber = typeof effectiveRank === "string" ? parseInt(effectiveRank, 10) : effectiveRank;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = function getOrdinalSuffix(n) {
      const mod10 = n % 10;
      const mod100 = n % 100;
      if (mod10 === 1 && mod100 !== 11) {
        return "st";
      }
      if (mod10 === 2 && mod100 !== 12) {
        return "nd";
      }
      if (mod10 === 3 && mod100 !== 13) {
        return "rd";
      }
      return "th";
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const getOrdinalSuffix = t3;
  let dateString;
  let t4;
  if ($[1] !== decisionTime) {
    const dateTime = decisionTime ? new Date(decisionTime) : null;
    dateString = dateTime ? dateTime.toLocaleString(undefined, {
      month: "short",
      day: "numeric"
    }) : null;
    t4 = dateTime ? dateTime.toLocaleString(undefined, {
      hour: "2-digit",
      minute: "2-digit"
    }) : null;
    $[1] = decisionTime;
    $[2] = dateString;
    $[3] = t4;
  } else {
    dateString = $[2];
    t4 = $[3];
  }
  const timeString = t4;
  let colorClasses;
  let textColorClass;
  let rankText;
  bb0: switch (rankNumber) {
    case 1:
      {
        colorClasses = "tw-bg-yellow-500/10 tw-text-yellow-400 tw-border-yellow-500/20";
        textColorClass = "tw-text-amber-400";
        rankText = "1st";
        break bb0;
      }
    case 2:
      {
        colorClasses = "tw-bg-iron-400/10 tw-text-iron-300 tw-border-iron-400/20";
        textColorClass = "tw-text-iron-300";
        rankText = "2nd";
        break bb0;
      }
    case 3:
      {
        colorClasses = "tw-bg-amber-600/10 tw-text-amber-500 tw-border-amber-600/20";
        textColorClass = "tw-text-amber-600";
        rankText = "3rd";
        break bb0;
      }
    default:
      {
        colorClasses = "tw-bg-iron-600/20 tw-text-iron-400 tw-border-iron-600/20";
        textColorClass = "tw-text-iron-500";
        rankText = `${rankNumber}${getOrdinalSuffix(rankNumber)}`;
      }
  }
  if (variant === "simple") {
    const t5 = `tw-flex tw-items-center tw-gap-1.5 tw-text-sm tw-font-semibold ${textColorClass}`;
    let t6;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <FontAwesomeIcon icon={faTrophy} className="tw-w-3.5 tw-h-3.5" />;
      $[4] = t6;
    } else {
      t6 = $[4];
    }
    const t7 = position > 1 && ` #${position}`;
    let t8;
    if ($[5] !== rankText || $[6] !== t7) {
      t8 = <span>{rankText}{t7}</span>;
      $[5] = rankText;
      $[6] = t7;
      $[7] = t8;
    } else {
      t8 = $[7];
    }
    let t9;
    if ($[8] !== dateString || $[9] !== timeString) {
      t9 = dateString && <span>· {dateString}{timeString && <span className="tw-hidden sm:tw-inline">, {timeString}</span>}</span>;
      $[8] = dateString;
      $[9] = timeString;
      $[10] = t9;
    } else {
      t9 = $[10];
    }
    let t10;
    if ($[11] !== t5 || $[12] !== t8 || $[13] !== t9) {
      t10 = <div className={t5}>{t6}{t8}{t9}</div>;
      $[11] = t5;
      $[12] = t8;
      $[13] = t9;
      $[14] = t10;
    } else {
      t10 = $[14];
    }
    return t10;
  }
  const t5 = `tw-flex tw-items-center tw-gap-1 tw-px-2 tw-py-0.5 tw-rounded tw-text-xs tw-font-semibold tw-border tw-border-solid tw-whitespace-nowrap ${colorClasses}`;
  let t6;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <FontAwesomeIcon icon={faTrophy} className="tw-size-2.5" />;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== position) {
    t7 = position > 1 && <span>#{position}</span>;
    $[16] = position;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== dateString || $[19] !== timeString) {
    t8 = dateString && <span className="tw-hidden md:tw-flex tw-items-center"><div className="tw-size-[3px] tw-rounded-full tw-bg-current tw-opacity-70" /><span className="tw-border-l tw-border-current/40 tw-px-2 tw-flex tw-items-center"><FontAwesomeIcon icon={faClock} className="tw-mr-1.5 tw-size-2.5" />{dateString}{timeString && <span className="tw-hidden sm:tw-inline">, {timeString}</span>}</span></span>;
    $[18] = dateString;
    $[19] = timeString;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== rankText || $[22] !== t5 || $[23] !== t7 || $[24] !== t8) {
    t9 = <div className={t5}>{t6}{rankText}{t7}{t8}</div>;
    $[21] = rankText;
    $[22] = t5;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  return t9;
};
export default WinnerDropBadge;